import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { ActiveToast } from 'components/layout'
import { ACTIVITY_STATES } from 'constants/enums'

export default class RPToasts extends Component {
  static propTypes = {
    onOpenLeaderApproval: PropTypes.func,
    residentialProject: PropTypes.object,
  }

  render() {
    const {
      residentialProject,
      onOpenLeaderApproval,
    } = this.props

    const state = get(residentialProject, 'state.value')
    const isAssessmentPositive = get(residentialProject, 'isAssessmentPositive')

    const showLeaderRequestToast = [ACTIVITY_STATES.assessment.id].includes(state) && isAssessmentPositive

    return (
      <div>
        <ActiveToast
          text='You can send now your Residential Project to Award Leader for approval.'
          intlKey='label.you_can_send_residential_project_to_leader'
          action='Send'
          actionKey='button.send'
          onClick={onOpenLeaderApproval}
          toShow={showLeaderRequestToast}
        />
      </div>
    )
  }
}
